import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TresciService } from '../tresci.service';
import { FormControls, Parameter } from '../shared/models/form-model/models/form-controlls.model';
import { Observable } from 'rxjs';
import { UserService } from '../user.service';
import { Contractor } from '../shared/models/user/contractor.model';
import { serialize } from 'class-transformer';
import { FileControl } from '../shared/models/form/file-control.model';
import { Country } from '../shared/models/order-register/order-estimate/country.model';
import { FormGroup } from '@angular/forms';
import { HtmlControl } from '../shared/models/form-model/models/html-control.model';
import { ActiveForm } from '../shared/models/form-model/models/active-form.model';
import { EditForm } from '../shared/models/form/edit-form.model';
import { TableColSaveArray } from './models/TableColSaveArray';
import { TableColSave } from './models/TableColSave';
import { OrderWarnings } from '../shared/models/orders/order-warnings/order-warnings.model';

@Injectable({
  providedIn: 'root'
})
export class TableSortService {
  constructor(private httpClient: HttpClient, public tresci: TresciService, public user: UserService) { }

  public getSettings(username:string): Observable<TableColSave[]> {
    
    return this.httpClient.post<TableColSave[]>('api/ActiveForm/getSettings', username, {
      headers: this.getHeaderJson(),
    });
  }

public setSettings(ustawienia: TableColSave[]): Observable<OrderWarnings[]> {
    return this.httpClient.post<OrderWarnings[]>('/api/ActiveForm/setSettings', ustawienia,
          { headers: this.user.getHeaderJson() });
  }


  

  
  

  public getHeader() {
    const header: HttpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + this.user.token).set('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8');
    /*header.append('Authorization', 'Bearer ' + this.token);*/
    return header;
  }

  public getHeaderJson() {
    const header: HttpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + this.user.token).set('Content-Type', 'application/json');
    /*header.append('Authorization', 'Bearer ' + this.token);*/
    return header;
  }

  public getHeaderFile() {
    const header: HttpHeaders = new HttpHeaders().set('Authorization', 'Bearer ' + this.user.token);
    /*header.append('Authorization', 'Bearer ' + this.token);*/
    return header;
  }

}
